const colours = {
  blue: "#678ffc",
  blueMedium: "#647bbd",
  darkBlue: "#374d8b",
  lightBlue: "#7d9bef",
};

export default colours;